import LandingPage from "./LandingPage.vue"
export default LandingPage
